var React = require('react');

function Account (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"10","r":"5","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M20 22C20 16 15 15 12 15C9 15 4 16 4 22","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Account.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Account;

Account.default = Account;
